import axios from 'axios';

const joinUrl = (base, path) => {
	const b = (base || '').replace(/\/+$/, '');
	const p = (path || '').replace(/^\/+/, '');
	return `${b}/${p}`;
};

const baseUrl = import.meta.env.VITE_TEMPLATE_API;
const baseKey =
	import.meta.env.VITE_TEMPLATE_KEY || import.meta.env.VITE_AUTH_KEY;

/**
 * GatesNow API client for no-login display mode.
 * Sends subscription key only (no Authorization), so APIM skips JWT
 * and applies the display IP allowlist.
 */
export const displayApiCall = async (uri, body, operation) => {
	const headers = {
		'Content-Type': 'application/json',
		'ocp-apim-subscription-key': baseKey,
	};
	const url = joinUrl(baseUrl, uri);
	const method = (operation || 'GET').toUpperCase();

	switch (method) {
		case 'PUT':
			return axios.put(url, body, { headers });
		case 'POST':
			return axios.post(url, body, { headers });
		case 'DELETE':
			return axios.delete(url, { headers });
		case 'GET':
		default:
			return axios.get(url, {
				headers,
				...(body?.params ? { params: body.params } : {}),
			});
	}
};
